module.exports = "/_next/static/images/475c1866bca4fc4552321b649a5081a6-sparkles.svg";